import { useEffect, useState } from "react";
import ExerciseSolution from "../../Course/ExerciseSolution";
import BarStats from "../../Utils/BarStats";
import Scoreboard from "../../Utils/ScoreBoard";
import ShowStudentResult from "./ShowStudentResult";
import { Button, Spin } from "antd";
import { t } from "../../../languages";

const buttonTexts = {
    'solution': 'showSolution',
    'stats': 'showStats',
    'scores': 'showClassifiaction',
    'waiting': 'ok'
}

const ShowCompetitionResults = ({ lang, screensToShow, exercises, currentExercise, studentResponse = null, statdata = null, scores = null, onFinish = null }) => {
    // console.log('ShowCompetitionResults:',/*  exercises, currentExercise, */ studentResponse);
    // console.log('ShowCompetitionResults statdata, scores:', statdata, scores);

    const [currentScreen, setCurrentScreen] = useState(0);

    useEffect(() => {
        if (screensToShow && currentScreen == (screensToShow.length - 1) && onFinish) onFinish();
    }, [currentScreen]);


    const handleNext = () => {
        setCurrentScreen(currentScreen + 1);
    }

    const scoreForStudent = scores && studentResponse && studentResponse.uid ? scores.find(aS => aS.id == studentResponse.uid) : null;

    const scorePosition = scores && studentResponse && studentResponse.uid ? scores.findIndex(aS => aS.id == studentResponse.uid) : false;
    const points = scoreForStudent ? scoreForStudent.points : 0;
    // console.log('ShowCompetitionResults points:', points);

    const nextScreen = screensToShow && screensToShow[currentScreen + 1] || null;

    return <>
        {screensToShow && screensToShow[currentScreen] === 'result' ? <ShowStudentResult lang={lang} response={studentResponse} points={points} inPodium={scorePosition < 3} /> : null}

        {screensToShow && screensToShow[currentScreen] === 'solution' ? <ExerciseSolution lang={lang} exercise={exercises[currentExercise - 1]} title={'solution'} /> : null}
        {screensToShow && screensToShow[currentScreen] === 'stats' ? <BarStats lang={lang} data={statdata} /> : null}
        {screensToShow && screensToShow[currentScreen] === 'scores' ? <Scoreboard lang={lang} scores={scores} /> : null}

        {nextScreen ? <div className="create-class-code">
            <Button className="button-white" key={currentExercise} onClick={handleNext}>{t(lang, buttonTexts[nextScreen])}</Button>
        </div> : null}
    </>;

}

export default ShowCompetitionResults